















import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import { v4 as uuid } from 'uuid'

export enum TooltipType {
    'INFORMATION',
    'QUESTION',
}

export enum TooltipAlign {
    'LEFT',
    'CENTER',
    'RIGHT',
}

export enum TooltipStyling {
    'NONE',
    'BETA',
}

@Component
export default class Tooltip extends Vue {
    @Prop({default: () => uuid()}) tid!: string
    @Prop({type: Number, default: TooltipType.INFORMATION}) type!: TooltipType
    @Prop({type: Number }) align!: TooltipAlign
    @Prop({type: Number }) styling!: TooltipStyling
    @Ref('parent') parent!: HTMLDivElement
    @Ref('tooltip') tooltip!: HTMLDivElement
    visible = false
    internalAlign = TooltipAlign.CENTER
    tooltipStyle = TooltipStyling.NONE
    viewportTimeout = null
    invisibleAlignments = []

    mounted() {
        if (this.align) {
            this.internalAlign = this.align
        }
        if (this.styling) {
            this.tooltipStyle = this.styling
        }
    }

    @Watch('visible')
    updateStyle() {
        const position = this.parent.getBoundingClientRect()

        if (this.tooltip) {
            this.tooltip.style.top = (position.top + position.height).toString() + 'px'
            if (this.tooltipStyle === TooltipStyling.BETA) {
                this.tooltip.style.top = (position.top + position.height + 10).toString() + 'px'
                this.tooltip.style.left = (position.left + (position.width / 2)).toString() + 'px'
            } else {
                this.tooltip.style.top = (position.top + position.height).toString() + 'px'
                this.tooltip.style.left = position.left.toString() + 'px'
            }
        }
        clearTimeout(this.viewportTimeout)

        if (this.visible) {
            this.checkViewport()
        }
    }

    checkViewport() {
        clearTimeout(this.viewportTimeout)
        this.viewportTimeout = setTimeout(() => {
            if (!this.inViewPort() && this.visible) {
                this.setNewAlign()
                this.setBetaStyling()
                this.checkViewport()
            }
        }, 150)
    }

    setNewAlign() {
        this.invisibleAlignments.push(this.internalAlign)

        if (!this.invisibleAlignments.includes(TooltipAlign.CENTER)) {
            this.internalAlign = TooltipAlign.CENTER
        }

        if (!this.invisibleAlignments.includes(TooltipAlign.RIGHT)) {
            this.internalAlign = TooltipAlign.RIGHT
        }

        if (!this.invisibleAlignments.includes(TooltipAlign.LEFT)) {
            this.internalAlign = TooltipAlign.LEFT
        }
    }

    setBetaStyling() {
        this.invisibleAlignments.push(this.tooltipStyle)

        if (!this.invisibleAlignments.includes(TooltipStyling.NONE)) {
            this.tooltipStyle = TooltipStyling.NONE
        }

        if (!this.invisibleAlignments.includes(TooltipStyling.BETA)) {
            this.tooltipStyle = TooltipStyling.BETA
        }
    }

    get componentName() {
        return this.type === TooltipType.INFORMATION ? 'icon-info-circle' : 'icon-question-mark'
    }

    get componentClasses() {
        return {
            'tooltip__content': true,
            'tooltip__content--align-left': this.internalAlign === TooltipAlign.LEFT,
            'tooltip__content--align-center': this.internalAlign === TooltipAlign.CENTER,
            'tooltip__content--align-right': this.internalAlign === TooltipAlign.RIGHT,
            'tooltip__content--style-beta': this.tooltipStyle === TooltipStyling.BETA,
        }
    }

    inViewPort() {
        if (!this.tooltip) {
            return false
        }

        const position = this.tooltip.getBoundingClientRect()

        // We only check left and right since we only adjust horizontal alignment
        return position.left >= 0 && position.right <= (window.innerWidth || document.documentElement.clientWidth)
    }
}
